
import React from "react";
import _ from "lodash";
import { connect } from "react-redux";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
    }
})

class Attachment extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { documents } = this.props

        return (
            <div class="emailAttachments mb10">
                {documents.filter(d=>d.contentDisposition === 'attachment').map((e, index) => {
                    if (e.valid) {
                        let isDocument = 'document';
                        let fileIcon = 'word_file_icon';
                        const ext = e.fileName.split('.').pop()
                        if (ext === "jpeg" || ext === "png" || ext === "jpg") {
                            isDocument = "image";
                            fileIcon = 'image';
                        }

                        if (ext === "pdf") {
                            isDocument = "pdf";
                            fileIcon = 'pdf_icon';
                        }

                        if (ext === "zip" || ext === "rar") {
                            isDocument = "zip";
                            fileIcon = 'archive_zip_icon';
                        }

                        if (ext === "txt" || ext === "csv") {
                            isDocument = "txt";
                            fileIcon = 'description';
                        }

                        if (ext === "dat") {
                            isDocument = "data";
                            fileIcon = 'insert_drive_file';
                        }

                        const url = `/api/file/upload/${e.fileKey}`;
                        return (
                            <div class="commentDocs mr15 mb10" style={{ pointerEvents: "none" }}>
                                <span key={index} >
                                    {isDocument === 'document' && (
                                        <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${url}`} frameBorder="0" >

                                        </iframe>
                                    )}
                                    {(isDocument === 'image') && (
                                        <div class="imgWrapper">
                                            <img class="img-responsive" src={`${url}`} />
                                        </div>
                                    )}

                                    {(isDocument === 'pdf') && (
                                        <div class="imgWrapper">
                                            <iframe class="img-responsive" src={`${url}`} frameBorder="0" />
                                        </div>
                                    )}
                                    {isDocument === "data" && (
                                        <div class="fileNotSupportedContainer">
                                            <i class="material-icons-sharp">insert_drive_file</i>
                                        </div>
                                    )}
                                    {isDocument === "txt" && (
                                        <div class="fileNotSupportedContainer">
                                            <i class="material-icons-sharp">article</i>
                                        </div>
                                    )}

                                    {isDocument === "zip" && (
                                        <div class="fileNotSupportedContainer">
                                            <i class="material-icons-sharp">folder</i>
                                        </div>
                                    )}

                                    <div class="fileName">
                                        {isDocument === "zip" || isDocument === "pdf" || isDocument === "document" ? 
                                            <img src={`/images/${fileIcon}.png`} class="img-responsive mr5" /> : 
                                            <i class={`material-icons mr5 text-size20 ${isDocument === 'image' ? "imageIcon" : ""}`}>{fileIcon}</i> 
                                        }
                                        <span>
                                            {e.fileName}
                                        </span>
                                    </div>
                                </span>
                            </div>
                        )
                    } else {
                        return (
                            <div class="commentDocs mr15 mb10" style={{ pointerEvents: "none" }}>
                                <span>
                                    <div class="fileNotSupportedContainer">
                                        <i class="material-icons-sharp">insert_drive_file</i>
                                    </div>
                                    <div class="fileName">
                                        <i class="material-icons mr5 text-size20">description</i>
                                        <span>
                                            {e.fileName}
                                        </span>
                                    </div>
                                </span>
                            </div>
                        )
                    }

                }

                )}
            </div>
        );
    }

}
export default Attachment;